module.exports = __webpack_public_path__ + "media/images/flags/1x1/rus-d1891d5f7a7c604c9f5b253bb0dc6d8f.svg";